import {
  Component,
  OnInit,
  OnDestroy,
  inject,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  Injector,
  ViewContainerRef,
  ComponentRef,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormControlComponent, NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzRateModule } from 'ng-zorro-antd/rate';
import {
  FeedBack,
  FeedbackDrawerParams,
  Question,
  FeedBackByCase,
  CaseFeedBackReportResponse,
  PrintFeedBack,
} from './feedback';
import {
  finalize,
  Observable,
  of,
  Subject,
  take,
  takeUntil,
  BehaviorSubject,
  map,
} from 'rxjs';
import { FeedbackService } from './feedback.service';
import { LoaderService } from '../../../../core/services/loader.service';
import { CommonModule } from '@angular/common';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTableModule, NzTableQueryParams } from 'ng-zorro-antd/table';
import { DrawerService } from '../../../../core/services/drawer.service';
import { DRAWER_IDS } from '../../../../core/constants/drawer-ids.constant';
import { CommonService } from '../../../../shared/services/common.service';
import { FeedbackFormComponent } from './feedback-form/feedback-form.component';
import { DrawerHeaderComponent } from '../../../../components/drawer-header/drawer-header.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { InsightMode } from '../../insights.enums';
import { AuthService } from '../../../../core/services/auth.service';
import { PrintFeedbackComponent } from './print-feedback/print-feedback.component';
import { OrganizationModel } from '../../../organizations/organization.interface';
import { OrganizationService } from '../../../organizations/organization.service';
import { ErrorResponse } from '../../../../core/models/error.models';
import { InsightsDataService } from '../insights-data/insights-data.service';
import { ManageGraphComponent } from '../insights-data/manage-graph.component';
import { UserDatePipe } from '../../../../shared/pipes/user-date.pipe';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { GraphFilterComponent } from '../insights-data/data-graph/graph-filter/graph-filter.component';
import {
  BehaviorGraphDataResponse,
  frequencyDatasheetGraph,
  frequencyIntervalGraph,
  GraphFilterEvent,
  latencyGraph,
  partialIntervalGraph,
  replacementDataType,
} from '../insights-data/insights-data.interface';
import { format, parse } from 'date-fns';
import { DATE_FORMAT } from './feeback.enum';
@Component({
  selector: 'app-feedback',
  standalone: true,
  imports: [
    NzDividerModule,
    NzFormModule,
    UserDatePipe,
    NzRadioModule,
    NzRateModule,
    FormsModule,
    NzInputModule,
    NzButtonModule,
    CommonModule,
    ReactiveFormsModule,
    NzSpinModule,
    NzTableModule,
    DrawerHeaderComponent,
    SvgIconComponent,
    NzModalModule,
    NzInputModule,
    NzFormControlComponent,
    GraphFilterComponent,
  ],
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss',
})
export class FeedbackComponent
  extends ManageGraphComponent
  implements OnInit, OnDestroy
{
  private readonly drawerService = inject(DrawerService);
  private feedBackService = inject(FeedbackService);
  feedbackForm: FormGroup;
  insightMode = InsightMode;
  questions: Question[] = [];
  private destroy$ = new Subject<void>();
  pageSize = 10;
  pageIndex = 1;
  total = 0;
  sort = '';
  adminNote = '';
  sortOrder: number | undefined = undefined;
  feedbackDetails = {} as FeedbackDrawerParams;
  feedBackHistory$ = this.feedBackService.feedback$;
  hasIncompleteFeedBack = false;
  isFeedBackEditable = false;
  isModalVisible = false;
  reportData: CaseFeedBackReportResponse | null = null;
  loggedInUserId = 0;
  counter = 1;
  printForm!: FormGroup;
  private printLoadingSubject = new BehaviorSubject<Record<string, boolean>>(
    {}
  );
  datasheetData: { id: number; value: string }[] = [
    { id: 1, value: 'Frequency/Duration Based Datasheet' },
    { id: 2, value: 'Latency' },
    { id: 3, value: 'Partial Interval' },
    { id: 4, value: 'Replacement Behavior' },
  ];

  graphImages: string[] = [];
  printLoading$ = this.printLoadingSubject.asObservable();
  listOfColumn = [
    {
      title: 'Member',
      key: 'name',
    },
    {
      title: 'Date & Time',
      key: 'submissionDate',
    },
    {
      title: 'Overall Score',
      key: 'overallScore',
    },
  ];

  loading$: Observable<boolean> = of(false);
  @ViewChild('viewFeedbackFormTpl') viewFeedbackFormTpl!: TemplateRef<void>;
  selectedFeedback: FeedBack | null = null;

  constructor(
    private fb: FormBuilder,
    private feedbackService: FeedbackService,
    private loaderService: LoaderService,
    private commonService: CommonService,
    cd: ChangeDetectorRef,
    private authService: AuthService,
    private injector: Injector,
    private viewContainerRef: ViewContainerRef,
    private orgService: OrganizationService,
    private dataService: InsightsDataService
  ) {
    super(cd);
    this.loading$ = this.loaderService.loading$;
    this.authService.userData$
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.loggedInUserId = user?.id || 0;
      });
    this.feedbackForm = this.fb.group({});
    this.printForm = this.fb.group({
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      viewType: [1, Validators.required],
      isTrendLineEnabled: [false, Validators.required],
      adminNote: [''],
    });
  }

  ngOnInit(): void {
    this.getDrawerParams();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setPrintLoading(itemId: string | number, isLoading: boolean): void {
    const currentState = this.printLoadingSubject.value;
    this.printLoadingSubject.next({
      ...currentState,
      [itemId]: isLoading,
    });
  }

  isPrintLoadingForItem(itemId: string | number): Observable<boolean> {
    return this.printLoading$.pipe(
      map((loadingState: Record<string, boolean>) => !!loadingState[itemId])
    );
  }

  getDrawerParams(): void {
    this.drawerService
      .getParams<FeedbackDrawerParams>(DRAWER_IDS.CASE_FEEDBACK)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.feedbackDetails = params;
          if (this.feedbackDetails.caseDetail) {
            this.isFeedBackEditable =
              this.feedbackDetails.caseDetail.isCaseFeedbackEditable || false;
            this.hasIncompleteFeedBack =
              this.feedbackDetails.caseDetail.isCaseFeedBackDue || false;
          }
        }
      });
  }

  onQueryParamsChange(params: NzTableQueryParams) {
    this.pageSize = params.pageSize;
    this.pageIndex = params.pageIndex;
    const currentSort = params.sort.find(item => item.value !== null);
    this.sort = (currentSort && currentSort.key) || 'organizationName';
    this.sortOrder =
      !!currentSort && currentSort.value
        ? currentSort.value === 'ascend'
          ? 0
          : 1
        : 0;
    this.loadData();
  }

  loadData() {
    this.loaderService.show();
    this.feedbackService
      .getFeedBackList({
        Page: this.pageIndex,
        PageSize: this.pageSize,
        SortOrder: this.sortOrder,
        Sort: this.sort,
        caseId: this.feedbackDetails.caseId || 0,
      })
      .pipe(
        finalize(() => this.loaderService.hide()),
        takeUntil(this.destroy$)
      )
      .subscribe({
        error: (error: Error) => {
          this.commonService.notify('error', error.message);
          this.cd.detectChanges();
        },
      });
  }

  submitFeedback(): void {
    this.viewFeedback({} as FeedBack, InsightMode.CREATE);
  }

  viewFeedback(item: FeedBack, mode = InsightMode.VIEW): void {
    if (mode !== InsightMode.CREATE && item.id) {
      this.fetchFeedbackData(item, mode);
    } else {
      this.openFeedbackDrawer(mode, item);
    }
  }

  onFilterChange(event: GraphFilterEvent) {
    this.printForm.patchValue({
      viewType: event.viewType,
      isTrendLineEnabled: event.isTrendLineEnabled,
      startDate: parse(event.startDate, DATE_FORMAT, new Date()),
      endDate: parse(event.endDate, DATE_FORMAT, new Date()),
      selectedTimeOption: event.selectedTimeOption || null,
    });
  }
  async getGraphData(
    selectedUnit: number,
    caseBehaviorId: number,
    graphType = 1
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (selectedUnit) {
        this.dataService
          .getBehaviorGraphData({
            CaseBehaviorId: caseBehaviorId,
            UnitName: selectedUnit,
            StartDate: format(
              this.printForm.get('startDate')?.value,
              DATE_FORMAT
            ),
            EndDate: format(this.printForm.get('endDate')?.value, DATE_FORMAT),
            graphType: graphType,
            viewType: this.printForm.get('viewType')?.value,
          })
          .pipe(take(1), takeUntil(this.destroy$))
          .subscribe({
            next: async res => {
              if (res.result) {
                try {
                  await this.manageBehvaiorGraphResponseData(
                    res.result,
                    selectedUnit,
                    graphType
                  );
                  resolve();
                } catch (error) {
                  console.error(
                    'Error in manageGraphResponseData for graph:',
                    error
                  );
                  reject(error);
                }
              } else {
                this.cd.markForCheck();
                resolve();
              }
            },
            error: (error: ErrorResponse) => {
              console.error('API error for graph:', selectedUnit, error);
              this.commonService.notify('error', error.message);
              reject(error);
            },
          });
      } else {
        resolve();
      }
    });
  }

  async manageBehvaiorGraphResponseData(
    data: BehaviorGraphDataResponse,
    selectedUnit: number,
    graphType: number
  ) {
    await this.processBehaviorGraphData(
      data,
      selectedUnit,
      graphType,
      this.printForm?.get('viewType')?.value,
      this.printForm?.get('isTrendLineEnabled')?.value || false,
      async (unit, graphData, showInterval) => {
        await this.generateImages(unit, graphData, showInterval);
      }
    );
  }

  async generateImages(
    selectedUnit: number,
    data:
      | frequencyDatasheetGraph
      | latencyGraph
      | partialIntervalGraph
      | replacementDataType
      | frequencyIntervalGraph,
    showIntervalFrequency = false
  ) {
    const images = await this.feedBackService.generateGraphImage(
      this.viewContainerRef,
      selectedUnit,
      data,
      showIntervalFrequency
    );
    this.graphImages = [...this.graphImages, ...images];
    return;
  }

  showAdminNote(item: FeedBack) {
    this.isModalVisible = true;
    this.selectedFeedback = item;
  }

  async printFeedback() {
    try {
      this.setPrintLoading(this.selectedFeedback?.id || 0, true);
      const response = await this.feedbackService
        .getCaseFeedbackReportData(
          this.selectedFeedback?.id || 0,
          this.feedbackDetails.student.organizationId || 0
        )
        .pipe(take(1), takeUntil(this.destroy$))
        .toPromise();
      if (response?.result) {
        this.reportData = response.result;
        this.setPrintLoading(this.selectedFeedback?.id || 0, true);
        if (
          this.reportData &&
          this.reportData.behaviorSpecificQuestions.length > 0
        ) {
          const behaviorId =
            this.reportData.behaviorSpecificQuestions[0].caseBehaviorMappingId;
          for (const data of this.datasheetData) {
            const selectedUnit = data.id;
            if (selectedUnit === 1) {
              await this.getGraphData(selectedUnit, behaviorId, 2);
            }
            await this.getGraphData(selectedUnit, behaviorId, 1);
          }
        }
        if (this.selectedFeedback) {
          await this.print(this.selectedFeedback);
        }
      } else {
        this.commonService.notify(
          'error',
          'Failed to load feedback report data'
        );
      }
    } catch (error) {
      console.error('Error fetching feedback report data:', error);
      this.setPrintLoading(this.selectedFeedback?.id || 0, false);
    }
  }

  async print(item: FeedBack) {
    const caseDetail = this.feedbackDetails.caseDetail;
    const factory = this.viewContainerRef.createComponent(
      PrintFeedbackComponent,
      {
        injector: this.injector,
      }
    );
    const componentElement = factory.location.nativeElement;
    componentElement.style.display = 'none';

    await Promise.all([
      this.orgService
        .getOrganization(caseDetail?.student.organizationId)
        .toPromise(),
    ])
      .then(async ([orgRes]: [OrganizationModel | undefined]) => {
        let base64Image = '';
        if (orgRes && orgRes.logoUrl) {
          base64Image = await this.commonService.getBase64ImageFromUrl(
            orgRes.logoUrl
          );
        } else {
          base64Image = await this.commonService.getBase64ImageFromUrl(
            '/assets/images/logo.png'
          );
        }
        factory.instance.feedbackData = {
          logo: base64Image,
          caseDetail: caseDetail,
          orgDetail: orgRes,
          feedbackDetail: this.reportData || null,
          notes: this.printForm.get('adminNote')?.value || '',
          graphImages: this.graphImages,
        } as PrintFeedBack;
        this.waitForInitialization(factory).then(() => {
          factory.instance.printPDF();
          factory.destroy();
          this.commonService.notify(
            'success',
            'Feedback Report has been printed successfully'
          );
          this.setPrintLoading(item.id, false);
          this.graphImages = [];
          this.cd.markForCheck();
        });
      })
      .catch(e => {
        console.error(e);
        this.setPrintLoading(item.id, false);
        this.graphImages = [];
        this.cd.markForCheck();
      })
      .finally(() => {
        this.setPrintLoading(item.id, false);
        this.isModalVisible = false;
      });
  }
  waitForInitialization(factory: ComponentRef<PrintFeedbackComponent>) {
    return new Promise<void>(resolve => {
      const interval = setInterval(() => {
        if (factory.instance.initialized) {
          clearInterval(interval);
          resolve();
        }
      }, 10);
    });
  }
  private fetchFeedbackData(item: FeedBack, mode: InsightMode): void {
    this.loaderService.show();
    this.feedbackService
      .getFeedbackByCaseId(item.id)
      .pipe(
        finalize(() => this.loaderService.hide()),
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: response => {
          if (response.result) {
            this.openFeedbackDrawer(mode, response.result);
          } else {
            this.commonService.notify('error', 'Failed to load feedback data');
          }
        },
        error: error => {
          console.error('Error fetching feedback data:', error);
        },
      });
  }

  private openFeedbackDrawer(
    mode: InsightMode,
    data: FeedBack | FeedBackByCase
  ): void {
    this.drawerService
      .openDrawer(
        FeedbackFormComponent,
        this.viewFeedbackFormTpl as unknown as TemplateRef<object>,
        1170,
        true,
        undefined,
        {
          mode,
          data: data,
          student: this.feedbackDetails.student,
          caseId: this.feedbackDetails.caseId,
          supervisorName: this.feedbackDetails.supervisorName,
          caseDetail: this.feedbackDetails.caseDetail,
        },
        DRAWER_IDS.FEEDBACK_FORM
      )
      .afterClose.pipe(take(1), takeUntil(this.destroy$))
      .subscribe(() => {
        this.loadData();
      });
  }

  closeFeedBackFormDrawer() {
    this.drawerService.closeDrawer(DRAWER_IDS.FEEDBACK_FORM);
  }
  handleModalClose() {
    this.isModalVisible = false;
  }
}
